// "Select Icon" link under a field: opens the shared icon picker and emits the chosen class string.
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OmpPickerService } from '..';

@Component({
  selector: 'omp-icon-field',
  templateUrl: './omp-icon-field.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpIconFieldComponent {
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor(private picker: OmpPickerService) {}

  browse() {
    this.picker.pickIcon(this.value).then((icon) => {
      if (icon !== null) {
        this.valueChange.emit(icon);
      }
    });
  }

  clear() {
    this.valueChange.emit('');
  }
}
